module.exports = __webpack_public_path__ + "images/application/illustrations/suppressions-ca29f291.svg";